/** Annotations-table module */

/** Tables module */

/** Summary module */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnotationsTableComponent } from './annotations-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  declarations: [ AnnotationsTableComponent ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    AgGridModule
  ],
  providers: [],
  exports: [AnnotationsTableComponent]
})
export class AnnotationsTableModule { }
